// Moving script tags from the product page to this file.
import ShoppingCartDrawer from './modules/shopping_cart_drawer';

require("./product_info/vepa_product_info");

require("./product_info/product_gallery");


ShoppingCartDrawer.init('cart-drawer');



// Vue
import FitmentCheck from './vue/Product/FitmentCheck';
import { createApp } from "vue";

if (document.getElementById('fitment-check')) {
	createApp(FitmentCheck).mount('#fitment-check');
}

// Get the viewport width
let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

// Check if the viewport width is less than or equal to 768px (mobile)
if (viewportWidth <= 768) {
	// hide the table and show the cards
	document.getElementById('navTabs').style.display = 'none';
	document.getElementById('navTabsMobile').style.display = 'flex';
} else {
	// hide the cards and show the table
	if (document.getElementById('navTabsMobile') != null) {

		document.getElementById('navTabsMobile').style.display = 'none';
		document.getElementById('navTabs').style.display = 'flex';
	}
}

// Set the font-size of the tabs based on the viewport width
if (viewportWidth >= 768 && viewportWidth <= 1024) {
	// For tablets
	let navLinks = document.querySelectorAll('.nav-link');
	navLinks.forEach(function (navLink) {
		navLink.style.fontSize = '14px';
	});
} else {
	// For desktops
	let navLinks = document.querySelectorAll('.nav-link');
	navLinks.forEach(function (navLink) {
		navLink.style.fontSize = '1rem';
	});
}

// Add an event listener to check the screen size whenever the window is resized
window.addEventListener('resize', function () {
	// Get the new viewport width
	let newViewportWidth = window.innerWidth || document.documentElement.clientWidth;

	// Check if the new viewport width is less than or equal to 768px (mobile)
	if (newViewportWidth <= 768) {
		// hide the table and show the cards
		document.getElementById('navTabs').style.display = 'none';
		document.getElementById('navTabsMobile').style.display = 'flex';
	} else {
		// hide the cards and show the table
		if (document.getElementById('navTabsMobile') != null) {
			document.getElementById('navTabsMobile').style.display = 'none';
			document.getElementById('navTabs').style.display = 'flex';

		}
	}

	// Set the font-size of the tabs based on the viewport width
	if (viewportWidth >= 768 && viewportWidth <= 1024) {
		// For tablets
		let navLinks = document.querySelectorAll('.nav-link');
		navLinks.forEach(function (navLink) {
			navLink.style.fontSize = '14px';
		});
	} else {
		// For desktops
		let navLinks = document.querySelectorAll('.nav-link');
		navLinks.forEach(function (navLink) {
			navLink.style.fontSize = '1rem';
		});
	}
});

document.addEventListener("DOMContentLoaded", function () {

	if (validPromoShipping) {
		let promoText = ' Promo ground shipping: <b class="promoShippingPrice">$' + promoShippingPrice + '</b>';
		if (promoShippingPrice == 0) {
			promoText = ' <b>FREE</b> Ground Shipping';
		}

		let has_coupon = document.getElementById('couponsInfo').innerHTML,
			text = '<p style="padding-top: 10px; margin-bottom: 0px;">' +
				'<i class="ci-truck me-1"></i>' + promoText + '</p>';

		if (has_coupon) {
			document.getElementById('promoGroundShipping').style.display = 'none';
			document.getElementById('couponsInfo').innerHTML += '<br>' + text;
		} else {
			// let promoGroundShipping = document.getElementById('promoGroundShipping');
			// promoGroundShipping.style.display = 'block';
			// promoGroundShipping.innerHTML += '<i class="ci-truck me-1"></i>' + promoText;
		}

	}


	// });

	// Product status check
	if (productStatus == '0') {
		document.querySelectorAll('.btn-success').forEach(function (btn) {
			btn.setAttribute('disabled', true);
		});
		document.querySelector('current-size').style.color = 'grey';
	}



});
setTimeout(function () {
	//shopper approved
	var sa_products_count = 3;
	var sa_date_format = 'F j, Y';
	var sa_product = window.vrdata.product['id'];
	(function (w, d, t, f, o, s, a) {
		o = 'shopperapproved';
		if (!w[o]) {
			w[o] = function () {
				(w[o].arg = w[o].arg || []).push(arguments)
			};
			s = d.createElement(t), a = d.getElementsByTagName(t)[0];
			s.defer = 1;
			s.src = f;
			a.parentNode.insertBefore(s, a)
		}
	})(window, document, 'script', '//www.shopperapproved.com/product/25706/' + sa_product + '.js');

	//shopper approved seal
	(function () {
		var js = window.document.createElement("script");
		js.src = '//www.shopperapproved.com/seals/certificate.js';
		js.type = "text/javascript";
		js.defer = true;
		document.getElementsByTagName("head")[0].appendChild(js);
	})();
}, 2500)






document.addEventListener("DOMContentLoaded", function () {

	// Floating buy button
	var buyBtn = document.getElementById("floatingBuyButton");
	window.addEventListener("scroll", function () {
		var elementTarget = document.getElementById("submit_add_to_cart") || document.getElementById("add_to_cart_with_options");
		if (elementTarget !== null && elementTarget.getBoundingClientRect().bottom <= 0) {
			buyBtn.classList.remove("visually-hidden");
			buyBtn.classList.add("opacity-100");
			buyBtn.parentElement.classList.add("shadow");
		}
		if (elementTarget !== null && elementTarget.getBoundingClientRect().top >= 0) {
			buyBtn.classList.add("visually-hidden");
			buyBtn.classList.remove("opacity-100");

			buyBtn.parentElement.classList.remove("shadow");
		}
	});


	// Mobile menu
	// We want to move the current selected tab to the second position on the navbar and make it active, then move the exisiting second tab to the dropdown menu

	// Detect when a dropdown item is clicked
	document.querySelectorAll('#mobileDropDown a').forEach(function (element) {
		element.addEventListener('click', function () {
			// Get the clicked tab details
			var clickedHref = this.getAttribute('href');
			var clickedText = this.textContent;

			// Get the current selected tab details
			var selectedTab = document.querySelector('#selectedMobileTab a');
			var selectedHref = selectedTab.getAttribute('href');
			var selectedText = selectedTab.textContent;

			// Swap the clicked and selected tabs
			this.setAttribute('href', selectedHref);
			this.textContent = selectedText;
			selectedTab.setAttribute('href', clickedHref);
			selectedTab.textContent = clickedText;

			// Update active state for tabs and tab panels
			document.querySelectorAll('#navTabsMobile .nav-link').forEach(function (tab) {
				tab.classList.remove('active');
				tab.setAttribute('aria-selected', 'false');
			});
			var activeTab = document.querySelector('#navTabsMobile .nav-link[href="' + clickedHref + '"]');
			if (activeTab) {
				activeTab.classList.add('active');
				activeTab.setAttribute('aria-selected', 'true');
			}

			document.querySelectorAll('.tab-pane').forEach(function (pane) {
				pane.classList.remove('active');
			});
			var activePane = document.querySelector(clickedHref);
			if (activePane) {
				activePane.classList.add('active');
			}
		});
	});

});



/**
 * *********** Affirm Pre-qualification Components *************/
window.affirm = {};
function setupAffirmComponent() {
	const getAffirmAmount = (config) => {
		fetch(config.promo_url, {
			headers: { 'Accept': 'application/json' },
			cache: 'default'
		})
			.then((resp) => resp.json())
			.then((promo) => {
				const affirmWrapper = document.querySelector('.affirm-ala-wrapper');
				if (affirmWrapper) {
					// Extract the "$xxx/mo" amount using regex
					const match = promo.promo.html_ala.match(/\$\d+\/mo/);
					if (match) {
						// Update the financing section with extracted amount, allowing HTML formatting
						document.getElementById('financingSection').innerHTML = `As low as <b>${match[0]}</b>`;
					}
					// Ensure the trigger is not overwritten
					affirmWrapper.innerHTML = promo.promo.html_ala;
				}

				const prequalLink = document.querySelector('.affirm-modal-trigger');
				if (prequalLink !== null) {
					prequalLink.setAttribute('target', "_blank");
					prequalLink.href = config.link;
				}
			});
	}

	if (window.vrdata.affirm && window.vrdata.affirm.enabled) {
		setTimeout(getAffirmAmount, 3500, window.vrdata.affirm);
	}
}
document.addEventListener("DOMContentLoaded", setupAffirmComponent);
/************* end Affirm Pre-qualification Components *************/



/**
 * ********************** vr23 Footer Newsletter form submit ************************/
const SubmitNewsletterForm = function (event) {
	event.preventDefault();

	let formData = new FormData(event.target);
	const formParams = new URLSearchParams(formData);
	const errorToast = new bootstrap.Toast(document.getElementById('vr23_footer_embed_signup_error'));

	fetch('/newsletter/submit-new', {
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
		body: formParams,
		cache: 'default'
	}).then(resp => {
		if (!resp.ok) {
			throw new Error();
		}

		document.getElementById('vr23_footer_embed_signup').innerHTML = '<p class="text-light">Thank you! Check your email for special offers</p>';
	}).catch(err => {
		errorToast.show();
	});
}

document.getElementById('vr23_footer_embed_signup').addEventListener('submit', SubmitNewsletterForm);
/************************ end vr23 Footer Newsletter form submit ************************/



/**
 * *********** Open Sidebar Cart instead of sending to Shopping Cart page *************/
const ShoppingCartContentEvent = new CustomEvent('shopping_cart_contents_changed', {
	bubbles: true,
	detail: {
		qty: 0,
		subtotal: 0,
		products: {},
	}
});

const openCartSideBar = (event) => {
	event.preventDefault();

	let formData = new FormData(event.currentTarget);
	formData.append('is_silent', "1");
	const formParams = new URLSearchParams(formData);

	const errorToast = new bootstrap.Toast(document.getElementById('add_to_cart_error'));
	fetch(event.currentTarget.getAttribute("action"), {
		method: 'POST',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
		body: formParams,
		cache: 'default'
	}).then(resp => resp.json()).then((data) => {
		if (data.hasOwnProperty('response')) {
			if (data.response.success) {
				ShoppingCartContentEvent.detail.qty = data.response.total_products_count;
				ShoppingCartContentEvent.detail.subtotal = data.response.subtotal_int;
				ShoppingCartContentEvent.detail.products = data.response.cart_products;
				window.dispatchEvent(ShoppingCartContentEvent);
			} else {
				errorToast.show();
			}
		} else {
			errorToast.show();
		}
	}).catch(err => {
		errorToast.show();
	});
}

function setShoppingCartExperience() {
	const cartAddForms = document.getElementsByClassName('add_to_cart_form');
	if (cartAddForms === null || cartAddForms.length === 0) {
		return;
	}

	if (ADD_TO_CART_GO_CHECKOUT === undefined || ADD_TO_CART_GO_CHECKOUT) {
		return;
	}

	for (let ii = 0; ii < cartAddForms.length; ii++) {
		cartAddForms[ii].addEventListener('submit', openCartSideBar, { capture: true });
	}

	const productOptionForms = document.getElementsByClassName('options-form');
	if (productOptionForms !== null) {
		for (let ii = 0; ii < productOptionForms.length; ii++) {
			productOptionForms[ii].addEventListener('submit', openCartSideBar, { capture: true });
		}
	}
}
document.addEventListener("DOMContentLoaded", setShoppingCartExperience);
/************* end Open Sidebar Cart instead of sending to Shopping Cart page *************/




/** Suggested Products **/

document.addEventListener("DOMContentLoaded", function () {
	const productsContainer = document.getElementById('relatedProductsCarousel');
	const productId = PRODUCT_ID;

	// Wishlist functionality
	const wishlistButtons = document.querySelectorAll('.btn-wishlist');

	wishlistButtons.forEach(button => {
		button.addEventListener('click', function (event) {
			event.preventDefault();
			const action = button.getAttribute('href').includes('wishlist.add') ? 'add' : 'remove';
			const productID = new URLSearchParams(button.getAttribute('href').split('?')[1]).get('pid');
			console.log(`Wishlist action: ${action} for product ID: ${productID}`);

			const productInfo = {
				$value: window.vrdata.product.final_price,
				Price: window.vrdata.product.final_price,
				ProductID: productID,
				ProductName: window.vrdata.product.products_name,
				CategoryNames: window.vrdata.product.category_names,
				CategoryIDs: window.vrdata.product.category_ids,
				ImageURL: window.vrdata.product.image_url,
				URL: window.location.href,
				Manufacturer: window.vrdata.product.manufacturers_name,
				ProductModel: window.vrdata.product.products_model
			};

			if (action === 'add') {
				klaviyo.push(['track', 'Added to Wishlist', productInfo]);
			} else {
				klaviyo.push(['track', 'Removed from Wishlist', productInfo]);
			}

			// Delay the redirect to ensure Klaviyo event is sent
			setTimeout(function () {
				window.location.href = button.getAttribute('href');
			}, 1000); // Adjust the delay as needed
		});
	});

	fetch(`related_products_ajax.php?product_id=${productId}`)
		.then(response => response.json())
		.then(data => {

			const crossSell = data;  // Assuming the returned data has the same structure as crossSell

			if (crossSell.products.length === 0) {
				productsContainer.innerHTML = '<div class="col-12"><h3 class="text-center">No Related Products</h3></div>';
				return;
			}

			let productCards = '';
			Object.values(crossSell.products).forEach((product, index) => {
				const wishlistAction = product.in_wishlist ? 'wishlist.remove' : 'wishlist.add';
				const wishlistIcon = product.in_wishlist ? 'ci-heart-filled' : 'ci-heart';
				const wishlistTooltip = product.in_wishlist ? 'Remove From Wishlist' : 'Add to Wishlist';

				productCards += `
				<div class="col mb-2">
                    <div class="card product-card card-static">
                        <a href="?action=${wishlistAction}&pid=${product.products_id}" class="btn-wishlist btn-sm" type="button" data-bs-toggle="tooltip" data-bs-placement="left" title="${wishlistTooltip}" rel="nofollow"><i class="${wishlistIcon}"></i></a>
                        <a class="card-img-top d-block overflow-hidden" href="${product.url}">
                            <img  loading="lazy" alt="${product.products_name} - ${product.products_model} - Image ${index + 2}" src="${product.products_image_lrg}" class="img-responsive img-fill">
                        </a>
                        <div class="card-body py-4">
                            <a class="product-meta d-block fs-xs pb-1" href="${product.url}">Model #${product.products_model}</a>
                                <a class="product-title fs-sm h3" style="height: 65px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" href="${product.url}">${product.products_name}</a>
                            <div class="d-flex justify-content-between">
                                <div class="product-price"><span class="text-accent">${product.price}</span></div>
                                <div class="star-rating">
                                    <!-- Add your star rendering logic here -->
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
                `;
			});

			productsContainer.innerHTML = productCards;

		})
		.catch(error => {
			console.error('There was an error fetching the product data:', error);
		});
});



// Share Buttons
document.addEventListener('DOMContentLoaded', function () {
	var currentUrl = window.location.href;
	var encodedUrl = encodeURIComponent(currentUrl);



	// Twitter / 𝕏
	// var twitterBtn = document.getElementById('twitterShareButton');
	// var tweetText = "Check this out! @vividracing";
	// twitterBtn.href = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${tweetText}`;

	// Facebook
	var facebookBtn = document.getElementById('facebookShareButton');
	var shareText = encodeURIComponent("Check this out!"); // Your custom message
	facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${shareText}`;

	// Email
	var emailBtn = document.getElementById('emailShareButton');
	var subject = encodeURIComponent("Check out this page");
	var body = encodeURIComponent("I found this interesting: " + currentUrl);
	emailBtn.href = `mailto:?subject=${subject}&body=${body}`;
});


// Vehicle Reset
document.querySelectorAll('.vehicle-reset').forEach((el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();
		fetch('/ymm-json.php?request=reset').then((response) => {
			let url = new URL(window.location.href);
			url.searchParams.delete('class_9');
			url.searchParams.delete('class_8');
			url.searchParams.delete('class_year');
			window.location.replace(url.toString());
			window.location = "/";


		});
	});
});